module.exports = "<div><router-view></router-view></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/about/social-project/portfolio-page.vue
// module id = 351
// module chunks = 0